import { render, staticRenderFns } from "./acordian.vue?vue&type=template&id=cc69488e&scoped=true&"
import script from "./acordian.vue?vue&type=script&lang=js&"
export * from "./acordian.vue?vue&type=script&lang=js&"
import style0 from "./acordian.vue?vue&type=style&index=0&id=cc69488e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc69488e",
  null
  
)

export default component.exports